<template>
  <div class="wrapper" v-if="data != undefined">
    <Menu />
    <div class="header-area bg-transparent position-absolute w-100 border-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <a @click="$router.go(-1)" href="javascript:;">
              <span class="back-arrow mt-4"></span>
            </a>
          </div>
          <div class="col-6 text-right">
            <a
              href="javascript:;"
              @click="
                $openShare(
                  'https://www.anadoluefessk.org/haber/' + data.slug,
                  data.title
                )
              "
            >
              <span class="menu-dot mt-4"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="slider-box position-relative">
              <img :src="data.images.original" class="w-100 slider-image" />
              <h1 class="fs-32 fc-5 slider-title position-absolute z-9">
                {{ data.title }}
              </h1>
              <div class="news-gra"></div>
            </div>
          </div>
          <div class="col-12 p-0">
            <div
              class="tab-box"
              v-if="
                data.content.some(k => k.type == 'gallery') ||
                  data.content.some(k => k.type == 'matchstat')
              "
            >
              <div class="tab-header text-center bb-1">
                <div class="row no-gutters">
                  <div
                    class="col-4 tab-select"
                    :class="tab == 'general' ? 'active' : ''"
                    @click="changeTab('general')"
                  >
                    <h1
                      class="fs-16"
                      :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                    >
                      Haber
                    </h1>
                  </div>
                  <div
                    v-if="data.content.some(k => k.type == 'gallery')"
                    class="col-4 tab-select"
                    :class="tab == 'gallery' ? 'active' : ''"
                    @click="changeTab('gallery')"
                  >
                    <h1
                      class="fs-16"
                      :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                    >
                      Foto Galeri
                    </h1>
                  </div>
                  <div
                    v-if="data.content.some(k => k.type == 'matchstat')"
                    class="col-4 tab-select"
                    :class="tab == 'statistics' ? 'active' : ''"
                    @click="changeTab('statistics')"
                  >
                    <h1
                      class="fs-16"
                      :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                    >
                      İstatistik
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <transition name="fade">
            <div class="col-12 p-0" v-if="tab == 'general'">
              <div class="item-box p-3">
                <div class="row">
                  <div class="col-6">
                    <span class="fs-12 fc-3">{{
                      $dateString(data.date.date)
                    }}</span>
                  </div>
                </div>
                <div class="content-block pt-3">
                  <p
                    v-html="data.excerpt"
                    style="    font-size: 18px;
    margin-bottom: 10px; font-family: Roboto Slab"
                  ></p>
                  <p
                    v-html="
                      data.content.find(k => k.type == 'original').content
                    "
                  ></p>
                </div>
              </div>
              <Comment @commentDeleted="getComments" :data="comments">
                <template v-slot:comment>
                  <div class="add-comment">
                    <div class="comment-image">
                      <img
                        :src="$store.state.user.avatarUrl"
                        class="w-100 rounded-circle"
                      />
                    </div>
                    <div class="comment-area">
                      <textarea
                        placeholder="Yorum Yaz"
                        class="comment-input mt-2"
                        v-model="comment"
                      ></textarea>
                      <button
                        @click="sendComment"
                        class="confirm-button"
                        v-if="comment != null && comment != ''"
                      >
                        Yorum Yap
                      </button>
                    </div>
                  </div>
                </template>
              </Comment>
            </div>
          </transition>
          <transition name="fade">
            <div
              class="col-12 p-0"
              style="position: unset;min-height:100vh;"
              v-if="tab == 'gallery'"
            >
              <vue-masonry-gallery :imgsArr="images" @click="clickFn" @scrollReachBottom="getData"></vue-masonry-gallery>

            </div>
          </transition>

          <transition name="fade">
            <div
              class="col-12 p-0"
              v-if="tab == 'statistics'"
              style="margin-top: 20px"
            >
              <div class="tab-box">
                <div class="tab-header text-center bb-1">
                  <div class="row no-gutters">
                    <div
                      class="col-6 tab-select"
                      :class="statisticsType == 'home' ? 'active' : ''"
                      @click="statisticsType = 'home'"
                    >
                      <h1
                        class="fs-16"
                        :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                      >
                        {{
                          data.content.find(k => k.type == "matchstat").content
                            .home.name
                        }}
                      </h1>
                    </div>
                    <div
                      class="col-6 tab-select"
                      :class="statisticsType == 'away' ? 'active' : ''"
                      @click="statisticsType = 'away'"
                    >
                      <h1
                        class="fs-16"
                        :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                      >
                        {{
                          data.content.find(k => k.type == "matchstat").content
                            .away.name
                        }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="item-box p-3" style="margin-top: 0px">
                <PlayerStatistics
                  v-if="statisticsType == 'home'"
                  :isAnadoluEfes="
                    data.content.find(k => k.type == 'matchstat').content.home
                      .name == 'Anadolu Efes'
                  "
                  :data="
                    data.content.find(k => k.type == 'matchstat').content.home
                      .stats
                  "
                />

                <PlayerStatistics
                  v-if="statisticsType == 'away'"
                  :isAnadoluEfes="
                    data.content.find(k => k.type == 'matchstat').content.away
                      .name == 'Anadolu Efes'
                  "
                  :data="
                    data.content.find(k => k.type == 'matchstat').content.away
                      .stats
                  "
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    
    <Footer />
    <modal v-if="modalIsVisible" :closeModal="closeModal" :content="modalContent" :slug="modalSlug" />
  </div>

</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import Comment from "@/components/Comment";
import PlayerStatistics from "@/components/PlayerStatistics";
import Modal from "@/components/Modal";
import VueMasonryGallery from "vue-masonry-gallery";

import axios from "axios";
export default {
  name: "NewsDetail",
  components: {
    Footer,
    Menu,
    Header,
    Comment,
    PlayerStatistics,
    VueMasonryGallery,
    Modal
  },
  data() {
    return {
      tab: "general",
      statisticsType: "home",
      data: this.$route.params.data,
      comments: [],
      comment: null,
      activeStat: "home",
      modalIsVisible: false,
      modalContent: "",
      modalSlug: "",
      imgs: [],
      group: 0
    };
  },
  methods: {
    changeTab(tabName) {
      this.tab = tabName;
    },
    changeStatistics(team) {
      this.statisticsType = team;
    },
    getComments() {
      var data = new FormData();
      data.append("id", this.$route.params.slug);
      //data.append("user_token", this.$store.state.user.token);
      data.append("type", "news");

      axios
        .post("yorum", data)
        .then(res => {
          this.comments = res.data.data.comments;
        })
        .catch(err => {});
    },
    sendComment() {
      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "news");
      data.append("id", this.$route.params.slug);

      axios
        .post("yorum/ekle", data)
        .then(res => {
          if (res.data.status != true) {
            this.$notify({
              title: "Hata",
              message: res.data.data,
              type: "error"
            });
          } else {
            this.comment = null;
            this.getComments();
            this.$notify({
              title: "Başarılı",
              message: "Başarıyla yorum yapıldı.",
              type: "success"
            });
          }

          this.getComments();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onShare() {
      this.$openShare(
        "https://www.anadoluefessk.org/foto-galeri/" +
          this.data.content.find(k => k.type == "gallery").slug,
        this.data.title
      );
    },
    clickFn(event, { index, value }) {
      event.preventDefault();
      // if srcBig is set use it as href, if not then use href
      const href = this.images[index].href;
      this.modalIsVisible = true;
      this.modalContent = this.images[index].href;
      /**
      if (event.target.tagName.toLowerCase() == "img") {
        console.log("img clicked", index, value);
      }
       */
    },
    closeModal() {
      this.modalIsVisible = false;
    },
    getData() {
      console.log('scroll disabled.');
    }
  },
  created() {
    if (this.data == undefined) {
      this.$store.state.loading = true;
      axios.get("/haber/detay?slug=" + this.$route.params.slug).then(res => {
        
        this.data = res.data.data;
        this.getComments();
        this.$store.state.loading = false;

        if (res.data.data.content.some(k => k.type == "matchstat")) {
          if (
            res.data.data.content
              .find(k => k.type == "matchstat")
              .content.away.name.toLowerCase() == "anadolu efes"
          ) {
            this.statisticsType = "away";
          }
        }
      });
    } else {
      if (this.data.content.some(k => k.type == "matchstat")) {
        if (
          this.data.content
            .find(k => k.type == "matchstat")
            .content.away.name.toLowerCase() == "anadolu efes"
        ) {
          this.statisticsType = "away";
        }
      }
    }

    
  },
  computed: {
    images() {
      var imgs = [];

      if (this.data.content.find(k => k.type == "gallery")) {
        this.data.content
          .find(k => k.type == "gallery")
          .content.map(item => {
            imgs.push({
              href: item.image[1].thumb_960,
              src: item.image[2].thumb_256,
              slug: item.slug
            });
          });
      }

      return imgs;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/NewsDetail.vue